import { t } from "i18next";
import React from "react"
import i18n from "../../../i18n/i18n";
import { Container, Wrapper } from "./style";

export const EvtsFooter = () => {

  const onChangeLang = (value: string) => {
    i18n.changeLanguage(value); 
    window.location.reload();
  }

  return(
    <Container>
      <Wrapper padding="32px 18%" fontSize="0.7rem" background="darkBackground" textColor="offWhite">
        <div style={{gap: '22px'}}>
          <a target="_blank" href="https://eventials.com/plataforma-para-webinars-eventials/" rel="noreferrer">{t('footer.aboutUs')}</a>
          <a target="_blank" href="https://eventials.com/plataforma/" rel="noreferrer">{t('footer.eventials')}</a>
          <a target="_blank" href="https://eventials.movidesk.com/kb" rel="noreferrer">{t('footer.support')}</a>
          <a target="_blank" href="https://eventialsapi.docs.apiary.io/#" rel="noreferrer">{t('footer.api')}</a>
          <a target="_blank" href="https://status.eventials.com/" rel="noreferrer">{t('footer.status')}</a>
          <a target="_blank" href="https://blog.eventials.com/" rel="noreferrer">{t('footer.blog')}</a>
          <a target="_blank" href="https://eventials.com/contact/" rel="noreferrer">{t('footer.contact')}</a>
        </div>
        <div style={{gap: '22px'}}>
          <a target="_blank" href="https://www.facebook.com/eventials" rel="noreferrer"><img src="https://static.eventials.com/static/images/icon-facebook-white.svg" alt="facebook icon" /></a>
          <a target="_blank" href="https://twitter.com/eventials" rel="noreferrer"><img src="https://static.eventials.com/static/images/icon-twitter-white.svg" alt="twitter icon" /></a>
          <a target="_blank" href="https://www.instagram.com/eventials.webinars/" rel="noreferrer"><img src="https://static.eventials.com/static/images/icon-instagram-white.svg" alt="instagram icon" /></a>
          <a target="_blank" href="https://www.eventials.com/eventials/" rel="noreferrer"><img src="https://static.eventials.com/static/images/LogoIconografico_White.svg" alt="eventials icon" /></a>
          <a target="_blank" href="https://www.linkedin.com/company/eventials/" rel="noreferrer"><img src="https://static.eventials.com/static/images/icon-linkedin-white.svg" alt="linkedin icon" /></a>
        </div>
      </Wrapper>
      <Wrapper padding="16px 18%" fontSize="0.75rem"  background="offWhite" textColor="title">
        <div>
          <p>© 2023 Eventials</p>
          <a target="_blank" href="https://docs.google.com/a/eventials.com/viewer?embedded=true&url=https://contratos.eventials.com/Eventials-Termos_Gerais_de_Uso-v1.pdf" rel="noreferrer">{t('footer.usageTerms')}</a>
          <a target="_blank" href="https://eventials.com/portal-de-privacidade/" rel="noreferrer">{t('footer.privacyPortal')}</a>
          <a target="_blank" href="https://docs.google.com/a/eventials.com/viewer?embedded=true&url=https://contratos.eventials.com/Eventials_PoliticaDePrivacidade.pdf" rel="noreferrer">{t('footer.privacyPolicy')}</a>
          <a target="_blank" href="https://suporte.eventials.com/kb/article/160228/contratos-e-politicas-eventials" rel="noreferrer">{t('footer.contracts')}</a>
        </div>
        <div>
          <button onClick={() => onChangeLang('pt-br')}>Português (BR)</button>
          <button onClick={() => onChangeLang('en-us')}>English (US)</button>
          <button onClick={() => onChangeLang('es')}>Español (ES)</button>
        </div>
      </Wrapper>
    </Container>
  );
}